export const mapKeyWithSubmodule = {
  fuel: 'a4a-report-bahanbakar',
  'detail-history-vehicle': 'a2g-report-detailriwayatkendaraan',
  geolocation: 'a2a-report-geolokasi',
  alert: 'a3c-report-peringatan',
  door: 'a4b-report-pintu',
  'summary-geolocation': 'a2b-report-ringkasangeolokasi',
  'history-vehicle': 'a3a-report-riwayatkendaraan',
  temperature: 'a4d-report-temperatur',
  'summary-day': 'a2e-report-ringkasanhariankendaraan',
  'summary-day-driver': 'a2d-report-ringkasanharianpengemudi',
  'summary-stopped': 'a2f-report-waktuberhenti',
  'time-window': 'a4c-report-jendelawaktu',
  'summary-engine': 'a4e-report-detailjamkerja',
  'summary-engine-pto': 'a4f-report-detailjamkerjadanpto',
  'detail-pto': 'a4g-report-detailpto',
  'overspeed-durations': 'a3e-report-kecepatanmelebihibatasaman',
  'driver-score': 'a3d-report-penilaianpengemudi',
  'summary-alert': 'a3f-report-ringkasanperingatan',
  'offline-vehicle': 'a2h-report-kendaraanoffline',
  'service-schedules': 'm1a-maintenancescheduler',
  'summary-fuel': 'a4h-summaryfuel-report',
  'summary-day-fuel': 'a4i-summaryfueldaily-report',
  'history-connectivity-gps': 'a2i-report-riwayatkoneksigps',
  'historical-offline': 'a2j-report-riwayatoffline',
  'geofences-trip': 'a8-report-geofences-trip',
  'vehicle-last-location': 'a2l-report-vehiclestatus',
  'duration-in-geolocation': 'a2o-duration-dalam-geolokasi',
  'fuel-recapitulation': 'a2p-fuel-recapitulation',
  'summary-ritage-geofence': 'j2b-ritage-report',
  'summary-sensor-ciomas': 'a11c-custom-report-ciomas',
}

export const mapKeyWithAccessScope = {
  fuel: 'report_fuel:read',
  'detail-history-vehicle': 'report_detail_vehicle_trip:read',
  geolocation: 'a2a-report-geolokasi:read',
  'management-vehicle': 'report_management_vehicle:read',
  'management-driver': 'report_management_driver:read',
  alert: 'report_alert:read',
  door: 'report_door:read',
  'summary-geolocation': 'a2b-report-ringkasangeolokasi:read',
  'history-vehicle': 'report_vehicle_trip:read',
  temperature: 'raw_sensor_infos:read',
  'summary-day': 'report_summary_day_vehicle:read',
  'summary-day-driver': 'a2d-report-ringkasanharianpengemudi:read',
  'summary-stopped': 'report_stopped:read',
  'time-window': 'report_time_window:read',
  'summary-engine': 'a4e-detailjamkerja:read',
  'summary-engine-pto': 'a4f-detailjamkerjadanpto:read',
  'detail-pto': 'a4g-detailpto:read',
  'overspeed-durations': 'a3e-report-ringkasanpelanggaranpengemudi:read',
  'driver-score': 'report_driver_behaviour:read',
  'driver-score-v2': 'b4a-penilaian-pengemudi-v2:read',
  'summary-alert': 'a3f-report-ringkasanperingatan:read',
  'offline-vehicle': 'report_vehicles_offline:read',
  'service-schedules': 'maintenance:read',
  'summary-fuel': 'a4h-summaryfuel-report:read',
  'summary-day-fuel': 'a4i-summaryfueldaily-report:read',
  'history-connectivity-gps': 'report_raw_sensor_hour:read',
  'historical-offline': 'report_historical_offline:read',
  'summary-work': 'report_summary_working_hours:read',
  'geofences-trip': 'a8-report-geofences-trip:read',
  'vehicle-last-location': 'report_vehicle_status:read',
  'duration-in-geolocation': 'duration_in_geolocation:read',
  'history-route': 'report_history_route:read',
  'summary-ritage-route': 'report_summary_ritage_route:read',
  'cost-analysis': 'tms:read,financial-record:read',
  'fleet-utilization-ijp': 'a11b-custom-report-ijp:read',
  'fuel-recapitulation': 'a2p-fuel-recapitulation:read',
  'summary-ritage-geofence': 'j2b-ritage-report:read',
  'summary-sensor-ciomas': 'a11c-custom-report-ciomas:read',
}

export const mapPeriode31DaysLeft = [
  'management-vehicle',
  'management-driver',
  'service-schedules',
  'summary-fuel',
  'summary-day-fuel',
  'history-connectivity-gps',
  'historical-offline',
  'summary-work',
  'temperature',
  'duration-in-geolocation',
  'history-vehicle',
  'fleet-utilization-ijp',
  'summary-sensor-ciomas',
]

export const mapCsv = [
  'fuel',
  'summary-stopped',
  'detail-history-vehicle',
  'geolocation',
  'summary-day',
  'summary-day-driver',
  'alert',
]

export const scopeReportScheduler = {
  fuel: ['report_fuel:read', 'share-report:read'],
  'detail-history-vehicle': ['report_detail_vehicle_trip:read', 'share-report:read'],
  geolocation: ['a2a-report-geolokasi:read', 'share-report:read'],
  'management-driver': ['report_management_driver:read', 'share-report:read'],
  'management-vehicle': 'report_management_vehicle:read',
  alert: 'report_alert:read',
  'summary-day': 'report_summary_day_vehicle:read',
  'offline-vehicle': 'report_vehicles_offline:read',
  temperature: ['raw_sensor_infos:read', 'scheduler_temperature:read'],
  'summary-day-driver': ['a2d-report-ringkasanharianpengemudi:read', 'share-report:read'],
  'summary-stopped': ['report_stopped:read', 'share-report:read'],
  'summary-fuel': ['a4h-summaryfuel-report:read', 'share-report:read'],
  'summary-day-fuel': ['a4i-summaryfueldaily-report:read', 'share-report:read'],
  'fuel-recapitulation': ['a2p-fuel-recapitulation:read', 'share-report:read'],
}
